import React, { Component, Fragment, useRef } from "react";
//import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardText,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";
import { configuration } from "../appConfig";
import ScanQR from "./ScanQR";
//import { configuration } from "../appConfig";
import "./createqr.css";
import "flatpickr/dist/themes/material_red.css";
import { connect } from "react-redux";
import axios from "axios";
import NewScanQR from "./NewScanQR";
import { clip } from "html5-qrcode/esm/core";
import DatePicker from "react-date-picker";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { Scatter } from "react-chartjs-2";
import ReactSelect from "react-select";
import Creatable from 'react-select/creatable';
import { components } from 'react-select';
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
const hzdPartnerIdList = ["6-200406", "16-220515"];

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class NewCreateQr extends Component {
  constructor(props) {
    super(props);
    this.qrRef = React.createRef(null);
    this.state = {
      selectedFile: "",
      regNo: "",
      vin: "",
      make: "",
      model: "",
      color: "",
      estimateId: "",
      client: "Adi",
      InsurenceName: "",
      insurenceLogo: "",
      makeModel: [],
      Models: [],
      email: "",
      comment: "",
      words: {},
      lang: "",
      modal: false,
      customerVorname: "",
      customerName: "",
      street: "",
      pincode: "",
      place: "",
      country: "",
      telmobile: "",
      teloffice: "",
      telprivate: "",
      RcBookNo: "",
      telNumber: "",
      // clientName: "",
      houseNumber: "",
      salutation: "",
      ec2_id: "",
      inv1: "",
      colorOptions: [], // Initialize as an empty array
    customInputValue: '',
      clients: [
        {
          SN: "1",
          Logo: "Adi.png",
          Notes: "Thank you",
          Email: "sa@pt3d.de",
          Name: "Adi",
        },
        {
          SN: "2",
          Logo: "AIG.png",
          Notes: "Thank you",
          Email: "sa@pt3d.de",
          Name: "AIG",
        },
      ],
      Category: "",
      categoryList: [
        "I. Kategorie",
        "II. Kategorie",
        "III. Kategorie",
        "IV. Kategorie",
        "V. Kategorie",
      ],
      ScannerNumber: "",
      ScannerLocation: "",
      error: [],
      modalError: [],
      // scanner State
      scanQR: false,
      scanResultData: "",
      qrClient: "",
      claimNumber: "",
      customerCompany: "",
      // customerName: "",
      PartnerName: "",
      kilometerStand: "",
      legacyMode: "",
      Category: "",
      actualVin: "",
      colorArr: {
        us: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Black", value: "000" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "Gold", value: "FFD700" },
          { title: "Green", value: "32AA32" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
          { title: "Yellow", value: "FFFF00" },
        ],
        de: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Blue", value: "0000FF" },
          { title: "Brown", value: "964B00" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Black", value: "000" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
        ],
        cz: [
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Black", value: "000" },
          { title: "Red", value: "960A0A" },
          { title: "Brown", value: "964B00" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Violet", value: "8F00FF" },
          { title: "Green", value: "32AA32" },
          { title: "Gold", value: "FFD700" },
          { title: "Yellow", value: "FFFF00" },
        ],
        ro: [
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Gold", value: "FFD700" },
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],

        si: [
          { title: "White", value: "FFFFFF" },
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Black", value: "000" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Brown", value: "964B00" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Violet", value: "8F00FF" },
          { title: "Green", value: "32AA32" },
          { title: "Gold", value: "FFD700" },
        ],
        fr: [
          { title: "Silver", value: "C0C0C0" },
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Gold", value: "FFD700" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],
        it: [
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Beige", value: "F5F5DC" },
          { title: "White", value: "FFFFFF" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Brown", value: "964B00" },
          { title: "Black", value: "000" },
          { title: "Gold", value: "FFD700" },
          { title: "Red", value: "960A0A" },
          { title: "Green", value: "32AA32" },
          { title: "Violet", value: "8F00FF" },
        ],
        nl: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Blue", value: "0000FF" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Orange", value: "F09600" },
          { title: "Red", value: "960A0A" },
          { title: "Violet", value: "8F00FF" },
          { title: "White", value: "FFFFFF" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Black", value: "000" },
        ],
        pl: [
          { title: "Beige", value: "F5F5DC" },
          { title: "Bronze", value: "CD7F32" },
          { title: "Brown", value: "964B00" },
          { title: "White", value: "FFFFFF" },
          { title: "Black", value: "000" },
          { title: "Red", value: "960A0A" },
          { title: "Violet", value: "8F00FF" },
          { title: "Blue", value: "0000FF" },
          { title: "Orange", value: "F09600" },
          { title: "Silver", value: "C0C0C0" },
          { title: "Grey", value: "E1E1E1" },
          { title: "Green", value: "32AA32" },
          { title: "Yellow", value: "FFFF00" },
          { title: "Gold", value: "FFD700" },
        ],
      },
      regDate: "",
      loader: false,
      customerJSON: {},
      searchTerm: '',
      showOptions: false,
      manufacturingYear : "",
    };
    this.flatpickrRef = React.createRef();
  }

  filEditForm = async () => {
    {
      this.props.location.state.detail._original
        ? // for Data Table
          this.setState({
            isUpdate: this.props.location.state.isUpdate,
            ...this.props.location.state.detail._original,
          })
        : // for normal
          this.setState({
            ...this.props.location.state.detail,
            regDate: this.formatDate(
              this.props.location.state.detail.regDate || ""
            ),
            regNo: this.props.location.state.detail.reg,
            isUpdate: this.props.location.state.isUpdate,
            InsurenceName:
              this.props.location.state.detail.InsurenceName ||
              this.props.location.state.detail.client,
            qrClient: this.props.location.state.detail.client,
            make: this.props.location.state.detail.make,
            // PartnerName: this.props.location.state.detail.customerName,
            // qrClient : this.props.location.state.detail.lastName,
            // TelMobile : this.props.location.state.detail.contactNumber
          });
      if (this.props.location.state.detail.vin.length == 17) {
        this.setState({
          actualVin: this.props.location.state.detail.actualVin
            ? this.props.location.state.detail.actualVin
            : this.props.location.state.detail.vin,
        });
      }
    }

    if (
      this.props.location.state.detail._original &&
      this.props.location.state.detail._original.make
    ) {
      // for data Table
      const make = this.props.location.state.detail._original.make;
      await this.getMakeModel();
      const Models = this.state.makeModel.filter((data) => {
        return data.Make == make;
      });
      this.setState({
        Models: Models[0].Model,
      });
    } else if (this.props.location.state.detail.make) {
      // for normal
      const make = this.props.location.state.detail.make;
      await this.getMakeModel();
      let Models = this.state.makeModel.filter((data) => {
        return data.Make == make;
      });
      let makeModels = this.state.makeModel;
      if (Models.length == 0) {
        Models = this.getModals(make);
        makeModels = [
          {
            Make: make,
            Model: [this.state.model, ...Models, ...this.state.Models].sort(),
          },
          ...this.state.makeModel,
        ];
        this.setState({
          Models: [this.state.model, ...this.state.Models, ...Models].sort(),
          makeModel: makeModels,
        });
      } else if (!Models[0].Model.includes(this.state.model)) {
        this.setState({
          Models: Models.length
            ? [this.state.model, ...Models[0].Model].sort()
            : "",
        });
      } else {
        this.setState({
          Models: Models.length ? Models[0].Model : "",
        });
      }
    } else {
      await this.getMakeModel();
    }
    this.setState({
      InsurenceName:
        this.props.location.state.detail.InsurenceName ||
        this.props.location.state.detail.client,
      manufacturingYear :this.props.location.state.detail.manufacturingYear ? JSON.parse(this.props.location.state.detail.manufacturingYear) : ""
    });
  };
  getMakeModel = async () => {
    await Axios.get("makeModel.json").then((r) => {
      this.setState({ makeModel: r.data });
      const makeOptions = [
        { value: '', label: '-- Select Make --' }, // Default option for make dropdown
        ...this.state.makeModel
          .filter(r => !r.label) // Exclude options with `label`
          .map(r => ({
            value: r.Make,
            label: r.Make,
          })),
      ];
      this.setState({ makeOptions });
    });
  };

  componentDidMount() {
    this.updateColorOptions();
    this.getInsurenceClients();
    const client = localStorage.getItem("client");
    this.setState({ client });

    if (this.props.location.state) {
      this.filEditForm();
    } else {
      this.getMakeModel();
    }

    // this.customerInfo();
    // this.vinFolderList();
    this.getLang();
  }
  updateColorOptions = () => {
    const { lang } = this.state;
    const colorOptionsMap = {
      us: [
        { label: "Beige", value: "F5F5DC" },
        { label: "Black", value: "000" },
        { label: "Blue", value: "0000FF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Brown", value: "964B00" },
        { label: "Gold", value: "FFD700" },
        { label: "Green", value: "32AA32" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Violet", value: "8F00FF" },
        { label: "White", value: "FFFFFF" },
        { label: "Yellow", value: "FFFF00" },
      ],
      "us-en": [
        { label: "Beige", value: "F5F5DC" },
        { label: "Black", value: "000" },
        { label: "Blue", value: "0000FF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Brown", value: "964B00" },
        { label: "Gold", value: "FFD700" },
        { label: "Green", value: "32AA32" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Violet", value: "8F00FF" },
        { label: "White", value: "FFFFFF" },
        { label: "Yellow", value: "FFFF00" },
      ],
      de: [
        { label: "Beige", value: "F5F5DC" },
        { label: "Blue", value: "0000FF" },
        { label: "Brown", value: "964B00" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Gold", value: "FFD700" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Green", value: "32AA32" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Black", value: "000" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Violet", value: "8F00FF" },
        { label: "White", value: "FFFFFF" },
      ],
      cz: [
        { label: "Beige", value: "F5F5DC" },
        { label: "White", value: "FFFFFF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Black", value: "000" },
        { label: "Red", value: "960A0A" },
        { label: "Brown", value: "964B00" },
        { label: "Blue", value: "0000FF" },
        { label: "Orange", value: "F09600" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Violet", value: "8F00FF" },
        { label: "Green", value: "32AA32" },
        { label: "Gold", value: "FFD700" },
        { label: "Yellow", value: "FFFF00" },
      ],
      ro: [
        { label: "White", value: "FFFFFF" },
        { label: "Blue", value: "0000FF" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Gold", value: "FFD700" },
        { label: "Beige", value: "F5F5DC" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Brown", value: "964B00" },
        { label: "Black", value: "000" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Green", value: "32AA32" },
        { label: "Violet", value: "8F00FF" },
      ],

      si: [
        { label: "White", value: "FFFFFF" },
        { label: "Beige", value: "F5F5DC" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Black", value: "000" },
        { label: "Blue", value: "0000FF" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Brown", value: "964B00" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Violet", value: "8F00FF" },
        { label: "Green", value: "32AA32" },
        { label: "Gold", value: "FFD700" },
      ],
      fr: [
        { label: "Silver", value: "C0C0C0" },
        { label: "Beige", value: "F5F5DC" },
        { label: "White", value: "FFFFFF" },
        { label: "Blue", value: "0000FF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Brown", value: "964B00" },
        { label: "Black", value: "000" },
        { label: "Gold", value: "FFD700" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Green", value: "32AA32" },
        { label: "Violet", value: "8F00FF" },
      ],
      it: [
        { label: "Orange", value: "F09600" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Beige", value: "F5F5DC" },
        { label: "White", value: "FFFFFF" },
        { label: "Blue", value: "0000FF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Brown", value: "964B00" },
        { label: "Black", value: "000" },
        { label: "Gold", value: "FFD700" },
        { label: "Red", value: "960A0A" },
        { label: "Green", value: "32AA32" },
        { label: "Violet", value: "8F00FF" },
      ],
      nl: [
        { label: "Beige", value: "F5F5DC" },
        { label: "Blue", value: "0000FF" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Brown", value: "964B00" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Gold", value: "FFD700" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Green", value: "32AA32" },
        { label: "Orange", value: "F09600" },
        { label: "Red", value: "960A0A" },
        { label: "Violet", value: "8F00FF" },
        { label: "White", value: "FFFFFF" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Black", value: "000" },
      ],
      pl: [
        { label: "Beige", value: "F5F5DC" },
        { label: "Bronze", value: "CD7F32" },
        { label: "Brown", value: "964B00" },
        { label: "White", value: "FFFFFF" },
        { label: "Black", value: "000" },
        { label: "Red", value: "960A0A" },
        { label: "Violet", value: "8F00FF" },
        { label: "Blue", value: "0000FF" },
        { label: "Orange", value: "F09600" },
        { label: "Silver", value: "C0C0C0" },
        { label: "Grey", value: "E1E1E1" },
        { label: "Green", value: "32AA32" },
        { label: "Yellow", value: "FFFF00" },
        { label: "Gold", value: "FFD700" },
      ],
      // Add other languages...
    };
  
    const colorOptions = [
      { value: '', label: '-- Select Color--' },
      ...(colorOptionsMap[this.props.lang] || []), // Ensure options exist for the selected language
    ];
   
    this.setState({ colorOptions },()=>{
      // this.sortColorArr()
    });
  };
  getInsurenceClients = () => {
    const partnerId = localStorage.getItem("partnerId");
    ///Axios.get(`insurenceClients/${partnerId}/insurenceList.json`).then(res=>{
    const url = configuration.getInsurenceClients + "?partnerId=" + partnerId;
    Axios.get(url).then((res) => {
      if (res.data) {
        this.setState({
          clients: res.data,
          InsurenceName: this.state.InsurenceName || res && res.data && res.data[0] && res.data[0].Name,
          insurenceLogo: this.state.InsurenceName
            ? this.getLogo(res.data, this.state.InsurenceName)
            : res && res.data && res.data[0] && res.data[0].Logo,
        });
      }
    });
  };
  getLogo = (data, InsurenceName) => {
    let logo;
    data.length &&
      data.filter((obj) => {
        if (obj.Name === InsurenceName) {
          logo = obj.Logo;
        } else {
          logo = data[0].Logo;
        }
      });
    return logo;
  };
  handleChange = (e, type) => {
    if (e && e.target) {
      // Standard input change event
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value });
      
      if (type === "InsurenceName") {
        this.state.clients.forEach(client => {
          if (client.Name === value) {
            this.setState({ insurenceLogo: client.Logo });
          }
        });
      }
    } else if (e && e.value) {
      // React Select change event
      const name = type; // type should be the name of the field
      const value = e.value;
      this.setState({ [name]: value });
      
      if (type === "InsurenceName") {
        this.state.clients.forEach(client => {
          if (client.Name === value) {
            this.setState({ insurenceLogo: client.Logo });
          }
        });
      }
    }
  };

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      const lang = localStorage.getItem("lang") || "en";
      this.setState({ words: res.data, lang }, () => {
        this.updateLocale();
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.lang!== this.props.lang) {
      this.updateColorOptions();
    }
    if (prevState.make != this.state.make) {
      const modelOptions = [
        { value: '', label: '-- Select Model --' }, // Default option for model dropdown
        ...
        this.state.Models.map(r => ({
          value: r,
          label: r,
        })),
      ];
      this.setState({ modelOptions });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.lang !== this.state.lang) {
      this.setState({
        lang: nextProps.lang,
      });
      this.updateColorOptions()
    } else return null;
  };

  translateColorName = async () => {
    const { colorArr } = this.state;
    colorArr &&
      colorArr.length &&
      colorArr.map(async (color) => {
        let colorName = await this.lang(color.title);
        color.colorName = colorName;
        return color;
      });
    return colorArr;
  };

  sortColorArr = async () => {
    const { colorArr } = this.state;
    await this.translateColorName();
    let finaleArr = await colorArr.sort((a, b) => {
      let nameA = a.colorName;
      let nameB = b.colorName;

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    });
    this.setState({
      colorArr: finaleArr,
    });
  };
  save = () => {
    const { vin, estimateId } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");
    // for Scanner Info location
    let error = [];
    let newVIN = client === "SWISS" ? estimateId : vin;
    // if(this.state.vin.trim() === '') {
    //   error.push('VIN')
    // }else
    if (!/^[a-zA-Z0-9_-]*$/.test(newVIN)) {
      error.push("inValidVIN");
    }
    if (newVIN.length > 17) {
      if (newVIN[17] !== "_") {
        error.push("maxLength");
      }
    }

    if (estimateId.trim() === "" && client === "SWISS") {
      error.push("orderID");
    }

    if (error.length) {
      this.setState({
        error: error,
      });
    } else {
      this.setState({
        error: [],
      });
      let url = `${configuration.vinExistsOrNot}?partnerId=${partnerId}&vin=${newVIN}`;
      if (newVIN.trim() === "") {
        this.saveQR();
      } else {
        Axios.get(url)
          .then((res) => {
            if (res.data.status === 200) {
              this.saveQR();
              this.handleChangeExtraImages(newVIN);
            } else if (
              res.data.status === 200 &&
              res.data.data == "vin not exists"
            ) {
              this.props.history.push("/newCreateQR");
            } else if (res.data.status === 500) {
              Swal.fire({
                title: `<p className="swal-custome-text">${this.lang(
                  "VIN already exists! Do you want to overwrite the order data? Overwriting will delete all scan images and analysis data for this VIN. Press <span>YES</span> to proceed and <span>NO</span> to return back."
                )}</p>`,
                showCancelButton: true,
                confirmButtonText: this.lang("Yes"),
                cancelButtonText: this.lang("No"),
                confirmButtonColor: "#d80707",
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.value) {
                  Axios.get(`${url}&deleteFolderData`)
                    .then((res) => {
                      if (res.data.success) {
                        this.saveQR();
                      }
                    })
                    .catch((err) => {
                      alert(err);
                    });
                }
              });
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
    }
  };
  handleChangeExtraImages = (newVIN) => {
    let partnerId = localStorage.getItem("partnerId");
    const vinNo = localStorage.getItem("selectedFile");
    let payload = {
      partnerId,
      vin: newVIN || vinNo,
      flag: 1,
    };

    const url = configuration.predamageFlag;
    axios.post(url, payload).then((res) => {});
  };
  saveQR = () => {
    const partnerId = localStorage.getItem("partnerId");
    const {
      vin,
      make,
      model,
      color,
      estimateId,
      regNo,
      client,
      InsurenceName,
      email,
      comment,
      PartnerName,
      customerCompany,
      claimNumber,
      qrClient,
      kilometerStand,
      Category,
      actualVin,
      regDate,
      customerJSON,
      customerVorname,
      customerName,
      street,
      pincode,
      place,
      country,
      telmobile,
      teloffice,
      telprivate,
      RcBookNo,
      // telNumber,
      // clientName,
      houseNumber,
      salutation,
      manufacturingYear,
      ec2_id,
      inv1,
      ScannerLocation,
    } = this.state;
    // if (this.state.vin) {
    // const url = `${configuration.imagePath}/api_v2/createVinRecord.php?vin=${vin.toUpperCase()}&partnerId=${partnerId}&regNo=${regNo}&make=${make}&model=${model}&color=${color}&estimateId=${estimateId}`;
    const url = `${configuration.imagePath}/api_v2/createVinRecord.php`;
    //window.open (url)
    //  this.props.history.go(url)

    const data = new FormData();
    // data.append("img", this.state.extTmages[i]"vin"];
    // if (client === "SWISS") {
    //   data.append("vin", estimateId.toUpperCase());
    //   data.append("client_type", "SWISS");
    // } else {
    //   data.append("vin", vin.toUpperCase());
    // }
    data.append(
      "vin",
      estimateId.toUpperCase() || actualVin.toUpperCase() || vin.toUpperCase()
    );
    data.append("partnerId", partnerId);
    data.append("regNo", regNo);
    data.append("make", make);
    data.append("model", model);
    data.append("color", color);
    data.append("estimateId", estimateId);
    data.append("email", email);
    data.append("comment", comment);
    data.append("InsurenceName", InsurenceName);
    // data.append("customerName", PartnerName);
    data.append("customerCompany", customerCompany);
    data.append("claimNumber", claimNumber);
    data.append("client", InsurenceName);
    // data.append("clientName", clientName);
    data.append("KilometerStand", kilometerStand);
    // data.append("Category", Category);
    data.append("actualVin", actualVin.toUpperCase());
    data.append("Place", place);
    data.append("country", country);
    data.append("CustomerVorname", customerVorname);
    data.append("CustomerName", customerName);
    data.append("salutation", salutation);
    data.append("street", street);
    data.append("PinCode", pincode);
    data.append("TelMobile", telmobile);
    data.append("TelOffice", teloffice);
    data.append("TelPrivate", telprivate);
    data.append("rcBookNo", RcBookNo);
    // data.append("telNumber", telNumber);
    data.append("houseNumber", houseNumber);
    data.append("ec2_id", ec2_id);
    data.append("inv1", inv1);
    data.append("ScannerLocation", ScannerLocation);
    data.append("manufacturingYear", manufacturingYear);

    hzdPartnerIdList.includes(partnerId) &&
      Object.keys(customerJSON).length > 0 &&
      data.append("customerJSON", JSON.stringify(customerJSON));
    partnerId === "15-220410" && data.append("regDate", regDate);
    partnerId === "demo-cz" && data.append("regDate", regDate);
    Axios.post(url, data).then(
      (res) => {
        if (res.data.status === 400) {
          this.props.history.push("/newCreateQR");
          Toast.fire({
            type: "error",
            title: "vin number is not valid",
          });
        } else {
          this.props.history.push("/qrlist");
        }
        // this.props.history.push("/qrlist");
        //window.open (`https://drivenscan.app/qr/DisplayQR.php?estimateID=&vin=${this.state.vin}&regno=&make=&model=&color=`,"_blank")
        // if(res.data.status === 200){
        // this.props.history.push("/qrlist");
        // }  else if(res.data.status === 400){
        //   Toast.fire({
        //     type: 'error',
        //     title: 'VIN number is invalid!'
        //   })
        // } else {
        // Toast.fire({
        //   type: 'error',
        //   title: 'Somethimg went to wrong!'
        // })
        // }
      }

      // window.open (`https://drivenscan.app/qr/DisplayQR.php?estimateID=&vin=${this.state.vin}&regno=&make=&model=&color=`,"_blank")
    );
    // }
    // else {
    //   alert("Select Vin");
    // }
  };
  // create Empty vin
  createEmpty = () => {
    // validation
    if (this.state.vin.length) {
      Toast.fire({
        type: "error",
        title: "Please do not fill VIN No.",
      });
    } else {
      let payload = {
        partnerId: localStorage.getItem("partnerId"),
        regNo: this.state.regNo,
        estimateId: this.state.estimateId,
        color: this.state.color,
        make: this.state.make,
        model: this.state.model,
        email: this.state.email,
        comment: this.state.comment,
        InsurenceName: this.state.InsurenceName,
      };
      let url = configuration.createEmptyVin;
      Axios.post(url, payload, {
        headers: {
          "Content-type": "application/json",
        },
      })
        .then((res) => {
          if (res.data.success) {
            Toast.fire({
              type: "success",
              title: res.data.message,
            });
          } else {
            Toast.fire({
              type: "error",
              title: res.data.message,
            });
          }
        })
        .catch((err) => {
          // if(err ===  "404"){
          //   Toast.fire({
          //     type: 'error',
          //     title: 'Empty Vin create successfull'
          //   })
          // } else if (err === "500"){
          //   Toast.fire({
          //     type: 'error',
          //     title: 'Internal Server Error. Please try again later.'
          //   })
          // } else{
          //   Toast.fire({
          //     type: 'error',
          //     title: 'else!!!!'
          //   })
          // }
        });
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };

  handleSubmit = (type) => {
    var content = this.state.base64;

    var fdata = content.replace("data:image/jpeg;base64,", "");
    var url =
      "https://vision.googleapis.com/v1/images:annotate?key=AIzaSyD2qzy2goNPeb2Xx89mDMoLOA_J_KCtV9s";
    //const url = "https://api.ocr.space/parse/image";
    var data = {
      requests: [
        {
          image: {
            content: fdata,
          },
          features: [
            {
              type: "TEXT_DETECTION",
              maxResults: 200,
            },
          ],
        },
      ],
    };

    Axios.post(url, data)
      .then((res) => {
        var a =
          res.data.responses[0].textAnnotations[0].description.split("\n")[0];
        var b = a.replace(/[^a-z0-9]/gi, "");

        this.setState({ [type]: b });
      })
      .catch((err) => {});
  };

  getOcr = (event, type) => {
    //var file = $('#fileform [name=fileField]')[0].files[0];

    let file = event.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: file,
        base64: reader.result,
      });
      this.handleSubmit(type);
    };

    //  const data = new FormData()
    //data.append('url', event.target.files[0]);
  };
  toggle = (type) => {
    let legacyMode;

    // Set legacyMode based on the type
    if (type === "scanner") {
      legacyMode = false;
    } else if (type === "file") {
      legacyMode = true;
    } else if (type === "cancel") {
      this.setState({
        modal: false,
        legacyMode: this.state.legacyMode, // Keep the current mode
      });
      return; // Exit early to avoid toggling modal again
    } else {
      legacyMode = this.state.legacyMode; // Maintain current state
    }

    // Toggle modal state
    this.setState((prevState) => ({
      modal: !prevState.modal,
      legacyMode,
    }));
  };

  update = () => {
    const {
      vin,
      make,
      model,
      color,
      estimateId,
      regNo,
      customerCompany,
      InsurenceName,
      email,
      comment,
      qrClient,
      claimNumber,
      PartnerName,
      customerName,
      partnerId,
      kilometerStand,
      Category,
      regDate,
      place,
      country,
      customerVorname,
      salutation,
      street,
      pincode,
      telmobile,
      teloffice,
      telprivate,
      RcBookNo,
      houseNumber,
      inv1,
      ScannerLocation,
      manufacturingYear
    } = this.state;
    let payload = {
      partnerId: partnerId,
      vin: vin.toUpperCase(),
      estimateId: estimateId,
      regNo: regNo,
      make: make,
      model: model,
      color: color,
      InsurenceName: InsurenceName,
      email: email,
      comment: comment,
      // customerName: PartnerName,
      customerCompany: customerCompany,
      claimNumber: claimNumber,
      client: InsurenceName,
      KilometerStand: kilometerStand,
      Category: Category,
      regDate: regDate,
      Place: place,
      country: country,
      CustomerName: customerName,
      CustomerVorname: customerVorname,
      salutation: salutation,
      street: street,
      PinCode: pincode,
      TelMobile: telmobile,
      TelOffice: teloffice,
      TelPrivate: telprivate,
      rcBookNo: RcBookNo,
      houseNumber: houseNumber,
      inv1: inv1,
      ScannerLocation: ScannerLocation,
      manufacturingYear : manufacturingYear

    };
    
    const url = configuration.updateQrList;
    Axios.post(url, payload)
      .then((res) => {
        if (res.data.success) {
          Toast.fire({
            type: "success",
            title: "Data Updated Successfully",
          });
          this.props.history.push("/qrlist");
        } else if (res.data.status === 400) {
          Toast.fire({
            type: "error",
            title: "VIN number is invalid!",
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Somethimg went to wrong!",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: err,
        });
      });
  };
  // handleScanWebCam = (newData, qrString, Client) => {
  //   if (Client) {
  //     if (localStorage.getItem("client") === "SWISS") {
  //       this.setState({
  //         qrClient: Client,
  //       });
  //     }
  //   }
  //   this.setState(
  //     {
  //       scanQrData: newData,
  //       qrString,
  //     },
  //     () => this.toggle()
  //   );
  //   if (newData) {
  //     this.  (newData);
  //   }
  // };
  handleScanWebCam = (newData, qrString, Client) => {
    if (Client && localStorage.getItem("client") === "SWISS") {
      this.setState({
        qrClient: Client,
      });
    }

    this.setState(
      {
        scanQrData: newData,
        qrString,
      },
      () => {
        if (newData) {
          this.finalMatch(newData);
          this.toggle("cancel"); // Close the modal if new data is found
        } else {
          this.toggle(); // Just toggle for any other case
        }
      }
    );
  };

  finalMatch = async (dataArray) => {
    const { qrClient } = this.state;
    const client = localStorage.getItem("client");
    let orderNoValue = null;
    let actualVinValue = null;
    let regNoValue = null;
    console.log(dataArray);
    dataArray.length &&
      dataArray.map((arr) => {
        
        arr.length &&
          arr.map((r, i) => {
            if (i % 2 === 0) {
              let decodedValue;
              if (arr[i + 1] !== undefined) {
                decodedValue = decodeURIComponent(
                  arr[i + 1].replace(/\+/g, " ")
                );
              }
              if (
                [
                  "OrderNo",
                  "Auftragsnummer",
                  "ActualVin",
                  "VIN",
                  "RegNo",
                  "KZ",
                ].includes(arr[i])
              ) {
                decodedValue = decodedValue.replace(/\./g, "");
              }
              if (
                arr[i] === "ActualVin" ||
                arr[i] === "vin" ||
                arr[i] === "VIN"
              ) {
                actualVinValue = decodedValue;
                this.setState({
                  actualVin: decodedValue,
                  vin: decodedValue,
                });
              } else if (
                arr[i] === "RegNo" ||
                arr[i] === "regno" ||
                arr[i] === "KZ"
              ) {
                regNoValue = decodedValue;
                this.setState({
                  regNo: decodedValue,
                });
              } else if (
                arr[i] === "OrderNo" ||
                arr[i] === "estimateID" ||
                arr[i] === "Auftragsnummer"
              ) {
                orderNoValue = decodedValue;
                this.setState({
                  estimateId: decodedValue,
                  vin: decodedValue,
                });
                // } else if (
                //   arr[i] === "Make" ||
                //   arr[i] === "make" ||
                //   arr[i] === "Marke"
                // ) {
                //   let Models = this.state.makeModel.filter((t) => {
                //     return t.Make == decodedValue;
                //   });
                //   this.setState({
                //     make: decodedValue,
                //     Models:
                //       Models.length && Models[0].Model ? Models[0].Model : [],
                //   });
              } else if (arr[i] === "client") {
                this.setState(
                  {
                    InsurenceName: decodedValue,
                  },
                  () => {
                    this.state.clients.map((client) => {
                      if (client.Name === decodedValue) {
                        this.setState({
                          insurenceLogo: client.Logo,
                        });
                      }
                    });
                  }
                );
              } else if (arr[i] === "PartnerName") {
                const parts = decodedValue.split(" ");
                const vorname = parts.length > 0 ? parts[0] : "";
                const name = parts.slice(1).join(" ");

                this.setState({
                  customerVorname: vorname,
                  customerName: name,
                });
              } else if (arr[i] === "claimNumber") {
                this.setState({
                  claimNumber: decodedValue,
                });
              } else if (
                arr[i] === "Make" ||
                arr[i] === "make" ||
                arr[i] === "Marke"
              ) {
                let Models = this.state.makeModel.filter((t) => {
                  return t.Make == decodedValue;
                });
                this.setState({
                  make: decodedValue,
                  Models:
                    Models.length && Models[0].Model ? Models[0].Model : [],
                });
              } else if (
                arr[i] === "Model" ||
                arr[i] === "model" ||
                arr[i] === "Typ"
              ) {
                setTimeout(() => {
                  let makeModels = [...this.state.makeModel];
                  let Models = [];
                  if (this.state.Models.length == 0) {
                    Models = this.getModals(this.state.make);
                    makeModels = [
                      {
                        Make: this.state.make,
                        Model: [
                          decodedValue,
                          ...Models,
                          ...this.state.Models,
                        ].sort(),
                      },
                      ...this.state.makeModel,
                    ];
                  }
                  this.setState({
                    model: decodedValue,
                    Models: [
                      decodedValue,
                      ...this.state.Models,
                      ...Models,
                    ].sort(),
                    makeModel: makeModels,
                  });
                }, 1000);
              }
            } else {
              return;
            }
          });
      });
    const vinValue = orderNoValue || actualVinValue || regNoValue;
    const estimateIdValue = orderNoValue;
    if (vinValue) {
      this.setState({
        actualVin: actualVinValue,
        vin: vinValue,
        estimateId: estimateIdValue,
      });
    }
  };
  getModals = (make) => {
    let Models = this.state.makeModel.filter((t) => {
      return (t.Make && t.Make.toLowerCase()) === make.toLowerCase();
    });
    Models =
      Models.length && Models[0].hasOwnProperty("Model") ? Models[0].Model : [];
    return Models.length ? Models : [];
  };

  formatDate(date) {
    date = date.split("-");
    return `${date[2]}-${date[1]}-${date[0]}`;
  }

  fetchJSON = async (JSON_data) => {
    const { clients } = this.state;
    if (JSON_data.hasOwnProperty("vehicle")) {
      let insuranceClients =
        (await clients) && clients.length > 0 && clients.map((e) => e.Name);
      this.setState(
        {
          customerJSON: JSON_data,
          vin: JSON_data.vehicle.vin,
          regNo: JSON_data.vehicle.nr,
          // estimateId: "estimate ID",
          color: JSON_data.vehicle.color,
          make: JSON_data.vehicle.maker,
          model: JSON_data.vehicle.model,
          email: JSON_data.customer.email,
          // comment: JSON_data.vehicle.color,
          // qrClient: JSON_data.customer.creator,
          // claimNumber: JSON_data.vehicle.color,
          customerCompany: JSON_data.customer.company,
          // PartnerName: JSON_data.vehicle.color,
          kilometerStand: JSON_data.vehicle.mileage,
          InsurenceName: insuranceClients.includes(JSON_data.customer.insurance)
            ? JSON_data.customer.insurance
            : "Adi",
        },
        () => {
          const { make, makeModel, model } = this.state;
          let Models = makeModel.filter((data) => {
            return data.Make == make;
          });
          let makeModels = makeModel;
          if (Models.length == 0) {
            Models = this.getModals(make);
            makeModels = [
              {
                Make: make,
                Model: [model, ...Models, ...this.state.Models].sort(),
              },
              ...makeModel,
            ];
            this.setState({
              Models: [model, ...this.state.Models, ...Models].sort(),
              makeModel: makeModels,
            });
          } else if (!Models[0].Model.includes(model)) {
            this.setState({
              Models: Models.length ? [model, ...Models[0].Model].sort() : "",
            });
          } else {
            this.setState({
              Models: Models.length ? Models[0].Model : "",
            });
          }

          this.setState(
            {
              loader: false,
            },
            () => {
              this.refs.JSONFileUploader.value = "";
            }
          );
        }
      );
    } else {
      this.setState({
        loader: false,
      });
      Toast.fire({
        type: "error",
        title: "JSON file isn't valid!",
      }).then(() => {
        this.refs.JSONFileUploader.value = "";
      });
    }
  };

  handleFileChange = (uploadedFile) => {
    this.setState({
      loader: true,
    });
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      try {
        this.fetchJSON(JSON.parse(fileReader.result));
      } catch (e) {
        Toast.fire({
          type: "error",
          title: "JSON file isn't valid!",
        }).then(() => {
          this.setState(
            {
              loader: false,
            },
            () => {
              this.refs.JSONFileUploader.value = "";
            }
          );
        });
      }
    };
    if (uploadedFile !== undefined) {
      fileReader.readAsText(uploadedFile);
    }
  };

  getObjKey = (lang) => {
    let keyName = lang;
    if (["de", "ch", "fr-ch"].includes(lang)) {
      keyName = "de";
    } else if (["fr-fr"].includes(lang)) {
      keyName = "fr";
    } else if (["us", "gb", "au", "ku", "ar"].includes(lang)) {
      keyName = "us";
    }

    if (!Object.keys(this.state.colorOptions).includes(keyName)) {
      return "us";
    }

    return keyName || "us";
  };

  handleLangChange = (event) => {
    const selectedLang = event.target.value;
    localStorage.setItem("lang", selectedLang);
    this.setState({ lang: selectedLang }, () => {
      this.updateLocale();
    });
  };
  updateLocale = () => {
    const { lang } = this.state;

    // Dynamically set month and weekday names based on the selected language
    const locale = {
      firstDayOfWeek: 1, // Set Monday as the first day of the week
      weekdays: {
        shorthand: [
          this.lang("sun"),
          this.lang("mo"),
          this.lang("tue"),
          this.lang("wed"),
          this.lang("thu"),
          this.lang("fri"),
          this.lang("sat"),
        ],
        longhand: [
          this.lang("sunday"),
          this.lang("monday"),
          this.lang("tuesday"),
          this.lang("wednesday"),
          this.lang("thursday"),
          this.lang("friday"),
          this.lang("saturday"),
        ],
      },
      months: {
        shorthand: [
          this.lang("january"),
          this.lang("february"),
          this.lang("march"),
          this.lang("april"),
          this.lang("may"),
          this.lang("june"),
          this.lang("july"),
          this.lang("august"),
          this.lang("september"),
          this.lang("october"),
          this.lang("november"),
          this.lang("december"),
        ],
        longhand: [
          this.lang("january"),
          this.lang("february"),
          this.lang("march"),
          this.lang("april"),
          this.lang("may"),
          this.lang("june"),
          this.lang("july"),
          this.lang("august"),
          this.lang("september"),
          this.lang("october"),
          this.lang("november"),
          this.lang("december"),
        ],
      },
    };

    if (this.flatpickrRef.current) {
      this.flatpickrRef.current.flatpickr.set("locale", locale);
    }
  };
  handleDateChange = (selectedDates, e) => {
    if (selectedDates.length > 0) {
      const formattedDate = this.formatDate(selectedDates[0]);
      this.setState({ inv1: formattedDate });
    } else {
      this.setState({ inv1: "" });
    }
  };

  formatDate = (date) => {
    const client = localStorage.getItem("client");
    if (!(date instanceof Date) || isNaN(date)) {
      return "";
    }
    return moment(date).format((client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY");
  };

  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value, showOptions: true });
  };

  // handleSelectChange = (e) => {
  //   const selectedMake = e.target.value;
  //   const Models = this.state.makeModel.find(
  //     (t) => t.Make === selectedMake
  //   );

  //   this.setState({
  //     make: selectedMake,
  //     Models: Models ? Models.Model : [], // Safeguard against undefined
  //     searchTerm: selectedMake, // Keep selected make in the search input
  //     showOptions: false, // Hide dropdown after selection
  //   });
  // };

  handleDropdownToggle = () => {
    this.setState((prevState) => ({
      showOptions: !prevState.showOptions,
    }));
  };

  handleMakeChange = (selectedOption) => {
    const selectedMake = selectedOption ? selectedOption.value : '';
    const selectedMakeModel = this.state.makeModel.find(t => t.Make === selectedMake);
    const Models = (selectedMakeModel && selectedMakeModel.Model) || []; // Fallback to an empty array if not found

    this.setState({
      make: selectedMake,
      Models,
      model: '', // Reset model selection when make changes
    });
  };

  handleModelChange = (selectedOption) => {
    const selectedModel = selectedOption ? selectedOption.value : '';
    this.setState({ model: selectedModel });
  };
  handleColorChange = (selectedOption) => {
    const selectColor = selectedOption ? selectedOption.label : '-- Select Color--';
    this.setState({ color: selectColor });
  };
  // Handles input change in the select component
  handleInputChange = (inputValue) => {
    this.setState({ customInputValue: inputValue });
    return inputValue;
  };
  handleMakeInputChange = (inputValue) => {
    this.setState({ customInputValue: inputValue });
    return inputValue;
  };
  handleModalInputChange = (inputValue) => {
    this.setState({ customInputValue: inputValue });
    return inputValue;
  };

  // Handles adding new color options
  handleCreateOption = (inputValue) => {
    if (inputValue && !this.state.colorOptions.some(option => option.value === inputValue)) {
      const newColorOption = { value: inputValue, label: inputValue};
  
      this.setState(prevState => ({
        colorOptions: [
          ...prevState.colorOptions,
          newColorOption
        ],
        color: inputValue, // Set the newly created option as selected
        customInputValue: '' // Clear the custom input field
      }));
    }
  };
  handleMakeOption = (inputValue) => {
    if (inputValue && !this.state.makeOptions.some(option => option.value === inputValue)) {
      const newMakeOption = { value: inputValue, label: inputValue };
  
      this.setState(prevState => ({
        makeOptions: [
          ...prevState.colorOptions,
          newMakeOption
        ],
        make: inputValue, // Set the newly created option as selected
        customMakeInputValue: '' // Clear the custom input field
      }));
    }
  };
  handleModalOption = (inputValue) => {
    if (inputValue && !this.state.modelOptions.some(option => option.value === inputValue)) {
      const newmodelOption = { value: inputValue, label: inputValue };
  
      this.setState(prevState => ({
        modelOptions: [
          ...prevState.colorOptions,
          newmodelOption
        ],
        model: inputValue, // Set the newly created option as selected
        customModalInputValue: '' // Clear the custom input field
      }));
    }
  };
  
  handleYearChange = (selectedOption) => {
    this.setState({ manufacturingYear: selectedOption.value });
    // if ((selectedOption.value)) {
    // }
  };
  // clearDate = () => {
  //   this.setState({ inv1: "" });
  //   if (this.flatpickrRef.current) {
  //     this.flatpickrRef.current.flatpickr.clear();
  //   }
  // };

  // openCalendar = () => {
  //   if (this.flatpickrRef.current) {
  //     this.flatpickrRef.current.flatpickr.open();
  //   }
  // };

  render() {
    //const selectedFile = localStorage.getItem("selectedFile");
    const {
      vin,
      regNo,
      error,
      legacyMode,
      isUpdate,
      actualVin,
      colorArr,
      regDate,
      loader,
      customerJSON,
      inv1,
      colorOptions,
      report_authorized,
    } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const client = localStorage.getItem("client");

    const { makeModel, model , Models} = this.state;
   
    // Transform data for react-select for model dropdown
   

    const makeOptions = [
      { value: '', label: '-- Select Make --' }, // Default option for make dropdown
      ...this.state.makeModel
        .filter(r => !r.label) // Exclude options with `label`
        .map(r => ({
          value: r.Make,
          label: r.Make,
        })),
    ];

     const modelOptions = [
      { value: '', label: '-- Select Model --' }, // Default option for model dropdown
      ...
      Models.map(r => ({
        value: r,
        label: r,
      })),
    ];

    // Transform data for react-select
    const currentColorArr = this.state.colorArr[this.state.lang] || [];

    // Transform data for react-select
    
    // const colorOptions = [
    //   { value: '', label: '-- Select Color--' }, // Default option
    //   ...currentColorArr.map((color) => ({
    //     value: color.value,
    //     label: color.title,
    //   })),
    // ];    

    // const colorOptions = [
    //   { value: '', label: '-- Select Color--' },
    //   ...this.state.colorOptions
    // ]

    const currentYear = new Date().getFullYear();

    const years = [
      { value: '', label: '-- Select Year --' }, // Default option
      ...Array.from({ length: currentYear - 1950 + 2 }, (_, index) => ({
        value: 1950 + index,
        label: 1950 + index,
      })).reverse(),
    ];

    const numberOnlyInputProps = {
      inputMode: 'numeric', // Mobile devices show numeric keyboard
      pattern: '[0-9]*', // Restrict input to numbers
    };
    return (
      <>
        <div className="animated fadeIn create_qr_main_wrapper">
          <Card>
            <Row>
              <Col md="12" sm="12">
                <Card>
                  {!this.state.isUpdate && (
                    <CardHeader className="d-flex align-items-center create_qr_header justify-content-between">
                      <>
                        <div>
                          <button
                            className="btn btn-danger"
                            type="button"
                            aria-expanded="false"
                            aria-haspopup="true"
                            style={{ margin: "10px 10px 10px 0px" }}
                            aria-label="Dropdown toggle"
                            onClick={() => this.toggle("scanner")}
                          >
                            {this.lang("scanQRCode")}
                          </button>
                          <span
                            className=" m-0 mx-3"
                            style={{ fontSize: "16px", fontWeight: "600" }}
                          >
                            {this.lang("or")}
                          </span>
                          <button
                            className="btn btn-danger"
                            type="button"
                            aria-expanded="false"
                            aria-haspopup="true"
                            style={{ margin: "10px 10px 10px 10px" }}
                            aria-label="Dropdown toggle"
                            onClick={() => this.toggle("file")}
                          >
                            {this.lang("browseQRCode")}
                          </button>
                        </div>
                        {hzdPartnerIdList.includes(partnerId) && (
                          <div>
                            <input
                              type="file"
                              ref="JSONFileUploader"
                              accept="application/JSON"
                              onChange={(e) =>
                                this.handleFileChange(e.target.files[0])
                              }
                              style={{
                                display: "none",
                              }}
                            />
                            <button
                              className="btn btn-danger mr-auto"
                              type="button"
                              aria-expanded="false"
                              aria-haspopup="true"
                              style={{ margin: "10px 10px 10px 10px" }}
                              aria-label="Dropdown toggle"
                              onClick={(e) => {
                                this.refs.JSONFileUploader.click();
                              }}
                              disabled={loader}
                            >
                              {loader ? (
                                <div className="text-center">
                                  <div className="spinner-border" role="status">
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </div>
                              ) : (
                                this.lang("Browse JSON")
                              )}
                            </button>
                            {Object.keys(customerJSON).length > 0 && (
                              <Button
                                className="mx-2 btn btn-danger"
                                title="Clear JSON"
                                onClick={() =>
                                  this.setState({ customerJSON: {} })
                                }
                              >
                                <i className="fa fa-close" />
                              </Button>
                            )}
                          </div>
                        )}
                      </>
                    </CardHeader>
                  )}
                  <div className="create_qr_content mt-3">
                    <Row className="pb-0 align-items-end">
                      <Col xl="12" lg="12" md="12" sm="12" xs="12">
                        {/* <p className="heading_text">Vehicle Data</p> */}
                        {localStorage.getItem("lang") === "fr" ||
                        localStorage.getItem("lang") === "it" ||
                        localStorage.getItem("client") === "POLAND" ||
                        localStorage.getItem("client") === "POLAND_HAIL" ||
                        localStorage.getItem("client") === "POLAND_GD" ? (
                          <p className="heading_text">
                            {this.lang("Information")}
                            <span> {this.lang("VEHICLE")}</span>{" "}
                          </p>
                        ) : (
                          <p className="heading_text">
                            {this.lang("VEHICLE")}
                            <span> {this.lang("Information")}</span>{" "}
                          </p>
                        )}
                      </Col>
                      {/* order number */}
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <>
                            <Label>
                              {this.lang("Order NO")}
                              {localStorage.getItem("client") === "SWISS" && (
                                <span style={{ fontSize: "10.5px" }}>
                                  <span
                                    style={{
                                      fontSize: "15.5px",
                                      color: "red",
                                    }}
                                  >
                                    *{" "}
                                  </span>
                                  <b
                                    style={{
                                      fontSize: "9px",
                                      fontWeight: "900",
                                    }}
                                  >
                                    ({this.lang("orderNoIsUsedAsMainRecordID")})
                                  </b>
                                </span>
                              )}
                            </Label>
                            <Input
                              type="text"
                              name="estimateId"
                              placeholder={this.lang("Order NO")}
                              onChange={(e) =>
                                this.handleChange(e, "estimateId")
                              }
                              value={this.state.estimateId}
                              disabled={((isUpdate && client === "SWISS") || report_authorized == 1)}
                            />
                            {error.includes("orderID") && (
                              <span style={{ color: "red" }}>
                                {this.lang("pleaseEnterOrderID")}
                              </span>
                            )}
                          </>
                        </FormGroup>
                      </Col>
                      {/* vin number */}
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <>
                            <Label>{this.lang("VIN")}</Label>
                            <Input
                              type="text"
                              name="actualVin"
                              placeholder={this.lang("VIN")}
                              onChange={(e) => this.handleChange(e, "vin")}
                              value={actualVin.toUpperCase()}
                              disabled={
                                ((partnerId !== "M-220701" && this.state.isUpdate) || report_authorized == 1)
                              }
                            />
                          </>
                        </FormGroup>
                      </Col>
                      {/* Regestration number */}
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <>
                            <Label>{this.lang("Registration No.")}</Label>
                            <Input
                              type="text"
                              onChange={this.handleChange}
                              name="regNo"
                              placeholder={this.lang("Registration No.")}
                              value={this.state.regNo}
                              disabled={report_authorized == 1}
                            />
                          </>
                        </FormGroup>
                      </Col>
                      {/* Claim no */}
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <>
                            <Label>{this.lang("Claim number")}</Label>
                            <Input
                              type="text"
                              onChange={this.handleChange}
                              name="claimNumber"
                              placeholder={this.lang("Claim number")}
                              value={this.state.claimNumber}
                              disabled={report_authorized == 1}
                            />
                          </>
                        </FormGroup>
                      </Col>
                      {
                        (client == "US" || client == "CANADA") ? (
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label htmlFor="city">{this.lang("Make")}</Label>
                            <Creatable
                              options={makeOptions}
                              value={makeOptions.find(option => option.value === this.state.make)  || { value: this.state.make, label: this.state.make }}
                              onChange={this.handleMakeChange}
                              onInputChange={this.handleMakeInputChange}
                              onCreateOption={this.handleMakeOption}
                              isDisabled={this.props.report_authorized === 1}
                              placeholder="Select Make"
                              className="custom_input"
                            />
                          </FormGroup>
                        </Col>
                        ) : (
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label htmlFor="city">{this.lang("Make")}</Label>

                          <select
                            className="form-control"
                            placeholder="Make"
                            disabled={report_authorized == 1}
                            onChange={(e) => {
                              const Models = this.state.makeModel.filter(
                                (t) => {
                                  return t.Make == e.target.value;
                                }
                              );

                              this.setState({
                                make: e.target.value,
                                Models: Models[0].Model,
                              });
                            }}
                            value={this.state.make}
                            name="make"
                          >
                            <option>-- Select--</option>
                            {this.state.makeModel.map((r, j) => (
                              <Fragment key={j}>
                                {r.label ? (
                                  <option
                                    disabled
                                    style={{ fontWeight: "800" }}
                                  >
                                    {this.lang(r.label)}
                                  </option>
                                ) : (
                                  <option value={r.Make}>{r.Make}</option>
                                )}
                              </Fragment>
                            ))}
                          </select>
                        </FormGroup>
                      </Col>
                        )
                      }
                       {
                        (client == "US" || client == "CANADA") ? ( 
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label>{this.lang("Model")}</Label>
                            <Creatable
                              options={modelOptions}
                              value={modelOptions.find(option => option.value === this.state.model)  || { value: this.state.model, label: this.state.model }}
                              onChange={this.handleModelChange}
                              onInputChange={this.handleModalInputChange}
                              onCreateOption={this.handleModalOption}
                              isDisabled={this.props.report_authorized === 1}
                              placeholder="Select Model"
                              className="custom_input"
                            />
                          </FormGroup>
                        </Col>
                         ) : (
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label>{this.lang("Model")}</Label>
                            <select
                              className="form-control"
                              placeholder="Model"
                              onChange={this.handleChange}
                              value={this.state.model}
                              name="model"
                              disabled={report_authorized == 1}
                            >
                              <option>--Select --</option>
                              {this.state.Models.length &&
                                this.state.Models.map((r, j) => (
                                  <option key={j} value={r}>
                                    {r}
                                  </option>
                                ))}
                            </select>
                          </FormGroup>
                        </Col>
                        )
                      }
                       {
                        (client == "US" || client == "CANADA") ? (
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label>{this.lang("Color")}</Label>
                            <Creatable
                                name="color"
                                options={colorOptions}
                                value={colorOptions.find(option => option.label === this.state.color) || { value: this.state.color, label : this.state.color == "" ? "-- Select Color --" :this.state.color  }}
                                onChange={this.handleColorChange}
                                onInputChange={this.handleInputChange}
                                onCreateOption={this.handleCreateOption}
                                isDisabled={this.props.report_authorized === 1}
                                placeholder="Select or Create Color"
                                className="custom_input"
                              />
                          </FormGroup>
                          </Col>
                        ) : (
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label>{this.lang("Color")}</Label>
                            <div className="input-group">
                              <input
                                className="form-control"
                                type="email"
                                id="input2-group3"
                                name="color"
                                placeholder="Select Color"
                                disabled
                                onChange={this.handleChange}
                                value={this.lang(this.state.color)}
                              />
                              <div className="input-group-append dropdown">
                                <select
                                  name="color"
                                  className="form-control p-2"
                                  onChange={this.handleChange}
                                  value={this.state.color}
                                  disabled={report_authorized == 1}
                                >
                                  <option value="">-- Select --</option>
                                  {colorArr[this.getObjKey(this.state.lang)].map(
                                    (row, ind) => (
                                      <option key={ind} value={row.title}>
                                        {" "}
                                        {this.lang(row.title)}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                            </div>
                          </FormGroup>
                        </Col>
                        )
                       }
                       {
                        (client != "US" && client != "CANADA") &&
                        <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label htmlFor="city">
                          {(client == "US" || client == "CANADA") ? this.lang("Odometer") : this.lang("Kilometer Stand")}
                          </Label>
                          <Input
                            type="text"
                            id="kilometerStand"
                            onChange={this.handleChange}
                            name="kilometerStand"
                            placeholder={this.lang("KM Stand")}
                            value={this.state.kilometerStand}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                       }
                    {
                      (client == "US" || client == "CANADA") && 
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                      <FormGroup>
                        <Label>{this.lang("Year")}</Label>
                        <ReactSelect
                          name="manufacturingYear"
                          options={years}
                          value={years.find(option => option.value === this.state.manufacturingYear) || years[0]}
                          onChange={this.handleYearChange}
                          isDisabled={this.props.report_authorized === 1}
                          placeholder="Select Year"
                          className="custom_input"
                          isSearchable={true}
                          onInputChange={(inputValue, actionMeta) => {
                            // Allow only numeric input
                            const numericInput = inputValue.replace(/\D/g, '');
                            if (inputValue !== numericInput) {
                              return;
                            }
                          }}
                          components={{
                            Input: (props) => (
                              <components.Input
                                {...props}
                                onKeyDown={(e) => {
                                  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
                                    e.preventDefault();
                                  }
                                }}
                              />
                            ),
                          }}
                        />
                      </FormGroup>
                      </Col>
                    }

                      {/* <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Client")}</Label>
                          <Input
                            type="text"
                            name="qrClient"
                            onChange={this.handleChange}
                            placeholder={this.lang("Client")}
                            value={this.state.qrClient}
                          />
                        </FormGroup>
                      </Col> */}
                      {/* <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Customer Name")}</Label>
                          <Input
                            type="text"
                            name="PartnerName"
                            onChange={this.handleChange}
                            placeholder={this.lang("Customer Name")}
                            value={this.state.PartnerName}
                          />
                        </FormGroup>
                      </Col> */}
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Customer Company")}</Label>
                          <Input
                            type="text"
                            onChange={this.handleChange}
                            name="customerCompany"
                            placeholder={this.lang("Customer Company")}
                            value={this.state.customerCompany}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("First registration")}</Label>
                          {/* <Input
                            type="text"
                            name="inv1"
                            onChange={this.handleChange}
                            placeholder={this.lang("First registration")}
                            value={this.state.inv1}
                          /> */}
                          <div className="main_datepicker_wrapper">
                            {/* <DatePicker
                              className="filter-date-picker"
                              name="inv1"
                              value={
                                inv1
                                  ? new Date(
                                      inv1.split(".").reverse().join("-")
                                    )
                                  : null
                              }
                              format="dd.MM.yyyy"
                              onChange={(date) => this.handleDateChange(date)}
                              onReady={(selectedDates, dateStr, instance) => {
                                instance.input.setAttribute("readonly", true);
                              }}
                            /> */}
                            {
                              report_authorized == 1 ? 
                              <Input
                              type="text"
                              value={this.state.inv1}
                              disabled={report_authorized == 1}
                            />
                              :
                              <Flatpickr
                                      ref={this.flatpickrRef}
                                      placeholder={(client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY"}
                                      className="filter-date-picker"
                                      options={{
                                        locale: {
                                          firstDayOfWeek: 1,
                                          weekdays: {
                                            shorthand: [
                                              this.lang("sun"),
                                              this.lang("mon"),
                                              this.lang("tue"),
                                              this.lang("wed"),
                                              this.lang("thu"),
                                              this.lang("fri"),
                                              this.lang("sat"),
                                            ],
                                            longhand: [
                                              this.lang("sunday"),
                                              this.lang("monday"),
                                              this.lang("tuesday"),
                                              this.lang("wednesday"),
                                              this.lang("thursday"),
                                              this.lang("friday"),
                                              this.lang("saturday"),
                                            ],
                                          },
                                          months: {
                                            shorthand: [
                                              this.lang("january"),
                                              this.lang("february"),
                                              this.lang("march"),
                                              this.lang("april"),
                                              this.lang("may"),
                                              this.lang("june"),
                                              this.lang("july"),
                                              this.lang("august"),
                                              this.lang("september"),
                                              this.lang("october"),
                                              this.lang("november"),
                                              this.lang("december"),
                                            ],
                                            longhand: [
                                              this.lang("january"),
                                              this.lang("february"),
                                              this.lang("march"),
                                              this.lang("april"),
                                              this.lang("may"),
                                              this.lang("june"),
                                              this.lang("july"),
                                              this.lang("august"),
                                              this.lang("september"),
                                              this.lang("october"),
                                              this.lang("november"),
                                              this.lang("december"),
                                            ],
                                          },
                                        },
                                        altInput: true,
                                          dateFormat: (client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY",
                                          altFormat: (client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY",
                                          allowInput: false, // Disable manual input
                                          parseDate: (datestr, format) => {
                                            return moment(
                                              datestr,
                                              format,
                                              true
                                            ).toDate();
                                          },
                                          formatDate: (date, format) => {
                                            return moment(date).format(format);
                                          },
                                        }}
                                        value={
                                          inv1
                                            ? moment(inv1, (client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY").toDate()
                                            : null
                                        }
                                        onChange={this.handleDateChange}
                                        onReady={(
                                          selectedDates,
                                          dateStr,
                                          instance
                                        ) => {
                                          instance.input.setAttribute(
                                            "readonly",
                                            true
                                          );
                                        }}
                                      />
                            }
                             
                          </div>
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label htmlFor="postal-code">
                            {this.lang("Insurance Client")}
                          </Label>
                          <select
                            className="form-control"
                            placeholder="Insurance client"
                            disabled={report_authorized == 1}
                            onChange={(e) =>
                              this.handleChange(e, "InsurenceName")
                            }
                            //  defaultValue={this.state.InsurenceName}
                            value={this.state.InsurenceName}
                            name="InsurenceName"
                          >
                            <option disabled={true} value="">-- Select --</option>
                            {this.state.clients &&
                              this.state.clients.length &&
                              this.state.clients.map((r, i) => (
                                <Fragment key={i}>
                                  {/* {partnerId === '15-220410' ?  */}
                                  {partnerId === "15-220410" ||
                                  partnerId === "demo-cz" ? (
                                    <option
                                      style={{
                                        fontWeight: `${
                                          [
                                            "Axa",
                                            "Slavia",
                                            "Direct",
                                            "Audatex",
                                            "Allianz",
                                            "AQ-SK",
                                          ].includes(r.Name)
                                            ? "800"
                                            : ""
                                        }`,
                                        color: `${
                                          [
                                            "Axa",
                                            "Slavia",
                                            "Direct",
                                            "Audatex",
                                            "Allianz",
                                            "AQ-SK",
                                          ].includes(r.Name)
                                            ? ""
                                            : "red"
                                        }`,
                                      }}
                                      value={r.Name}
                                    >
                                      {r.Name}
                                    </option>
                                  ) : (
                                    <option value={r.Name}>{r.Name}</option>
                                  )}
                                </Fragment>
                              ))}
                          </select>
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup className="text-center">
                          <img
                            className="qr_insurance_image"
                            alt={this.state.InsurenceName}
                            src={`${
                              configuration.imagePath
                            }/scanImages/${partnerId}/insurenceClients/${
                              this.state.insurenceLogo || ""
                            }`}
                          />
                        </FormGroup>
                      </Col>
                      {
                        (client == "US" || client == "CANADA") &&
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label htmlFor="city">
                          {(client == "US" || client == "CANADA") ? this.lang("Odometer") : this.lang("Kilometer Stand")}
                          </Label>
                          <Input
                            type="text"
                            id="kilometerStand"
                            onChange={this.handleChange}
                            name="kilometerStand"
                            placeholder={this.lang("KM Stand")}
                            value={this.state.kilometerStand}
                            disabled={report_authorized == 1}
                            />
                        </FormGroup>
                      </Col>
                          }
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Scanner Location")}</Label>
                          <Input
                            type="text"
                            name="ScannerLocation"
                            onChange={this.handleChange}
                            placeholder={this.lang("Scanner Location")}
                            value={this.state.ScannerLocation}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                       <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{(client == "US" || client == "CANADA") ? this.lang("Customer Id") : this.lang("stammnummer")}</Label>
                          <Input
                            type="text"
                            name="RcBookNo"
                            onChange={this.handleChange}
                            placeholder={(client == "US" || client == "CANADA") ? this.lang("Customer Id") : this.lang("stammnummer")}
                            value={this.state.RcBookNo}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="12" lg="12" md="12" sm="12" xs="12">
                        {/* <p className="heading_text">Customer Information</p> */}
                        <p className="heading_text">
                          {/* {
                          localStorage.getItem("lang") == "fr" &&
                          localStorage.getItem("lang") == "it" &&
                          localStorage.getItem("lang") == "pl" &&
                          localStorage.getItem("lang") !== "fr-ch" &&
                          localStorage.getItem("lang") !== "ch-fr" ? (
                            <>
                              {this.lang("Information")}
                              <span> {this.lang("General")}</span>
                            </>
                          ) : (
                            <>
                              {this.lang("General")}
                              {
                              localStorage.getItem("lang") !== "fr" &&
                              localStorage.getItem("lang") !== "fr-ch" &&
                              localStorage.getItem("lang") !== "ch-fr" ? (
                                <span> {this.lang("Information")}</span>
                              ) : null}
                            </>
                          )} */}
                          {localStorage.getItem("lang") === "fr" ||
                            localStorage.getItem("lang") === "it" ||
                            localStorage.getItem("client") === "POLAND" ||
                            localStorage.getItem("client") === "POLAND_HAIL" ||
                            localStorage.getItem("client") === "POLAND_GD" ? (
                              <p className="heading_text">
                                {this.lang("Information")}
                                <span> {this.lang("General")}</span>{" "}
                              </p>
                            ) : (
                              <p className="heading_text">
                                {this.lang("General")}
                                <span> {this.lang("Information")}</span>{" "}
                              </p>
                          )}
                        </p>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Salutation")}</Label>
                          {/* <Input
                                type="text"
                                name=""
                                placeholder={this.lang("Salutation")}
                                /> */}
                          <select
                            name="salutation"
                            className="form-control p-2"
                            value={this.state.salutation}
                            onChange={this.handleChange}
                            disabled={report_authorized == 1}
                          >
                            <option value="Ms.">Ms</option>
                            <option value="Mr.">Mr</option>
                            <option value="">No salutation</option>
                          </select>
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("First Name")}</Label>
                          <Input
                            type="text"
                            name="customerVorname"
                            onChange={this.handleChange}
                            placeholder={this.lang("First Name")}
                            value={this.state.customerVorname}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Last Name")}</Label>
                          <Input
                            type="text"
                            name="customerName"
                            onChange={this.handleChange}
                            placeholder={this.lang("Last Name")}
                            value={this.state.customerName}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Email Address")}</Label>
                          <Input
                            type="text"
                            name="email"
                            onChange={this.handleChange}
                            placeholder={this.lang("Email Address")}
                            value={this.state.email}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Mobile Number")}</Label>
                          <Input
                            type="text"
                            name="telmobile"
                            onChange={this.handleChange}
                            placeholder={this.lang("Mobile Number")}
                            value={this.state.telmobile}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Telephone Office")}</Label>
                          <Input
                            type="text"
                            name="teloffice"
                            onChange={this.handleChange}
                            placeholder={this.lang("Telephone Office")}
                            value={this.state.teloffice}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Telephone Private")}</Label>
                          <Input
                            type="text"
                            name="telprivate"
                            onChange={this.handleChange}
                            placeholder={this.lang("Telephone Private")}
                            value={this.state.telprivate}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("stammnummer")}</Label>
                          <Input
                            type="text"
                            name="RcBookNo"
                            onChange={this.handleChange}
                            placeholder={this.lang("stammnummer")}
                            value={this.state.RcBookNo}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col> */}
                    </Row>
                    <Row className="pt-0">
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Street")}</Label>
                          <Input
                            type="text"
                            name="street"
                            onChange={this.handleChange}
                            placeholder={this.lang("Street")}
                            value={this.state.street}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("House No")}</Label>
                          <Input
                            type="text"
                            name="houseNumber"
                            onChange={this.handleChange}
                            placeholder={this.lang("House No")}
                            value={this.state.houseNumber}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Postal Code")}</Label>
                          <Input
                            type="text"
                            name="pincode"
                            onChange={this.handleChange}
                            placeholder={this.lang("Postal Code")}
                            value={this.state.pincode}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("City")}</Label>
                          <Input
                            type="text"
                            name="place"
                            onChange={this.handleChange}
                            placeholder={this.lang("City")}
                            value={this.state.place}
                            disabled={report_authorized == 1}
                          />
                          {/* </FormGroup>
                          </Col>
                          <Col xl="3" lg="4" md="6" sm="6" xs="12">
                          <FormGroup>
                            <Label>{this.lang("State")}</Label>
                            <Input
                                type="text"
                                name=""
                                placeholder={this.lang("State")}
                                /> */}
                        </FormGroup>
                      </Col>
                      <Col xl="3" lg="4" md="6" sm="6" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Country")}</Label>
                          <Input
                            type="text"
                            name="country"
                            onChange={this.handleChange}
                            placeholder={this.lang("Country")}
                            value={this.state.country}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col xl="9" lg="9" md="9" sm="9" xs="12">
                        <FormGroup>
                          <Label>{this.lang("Notes")}</Label>
                          <Input
                            type="textarea"
                            name="comment"
                            onChange={this.handleChange}
                            placeholder={this.lang("Notes")}
                            value={this.state.comment}
                            disabled={report_authorized == 1}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="12">
                        <CardText>{this.state.qrString}</CardText>
                      </Col>
                      <Col lg="12" className="text-right">
                        {this.state.isUpdate ? (
                          <button
                            className="btn btn-danger btn-lg"
                            onClick={() => this.update()}
                            disabled={report_authorized == 1}
                          >
                            {this.lang("Update QR Details")}
                          </button>
                        ) : (
                          <>
                            <button
                              className="btn btn-danger btn-lg"
                              onClick={this.save}
                            >
                              {`${this.lang("Create Order")} / ${this.lang(
                                "Create QR"
                              )}`}
                            </button>
                          </>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
            </Row>
          </Card>
        </div>
        {/* Modal For QR */}
        <Modal
          toggle={() => this.toggle()}
          isOpen={this.state.modal}
          size="lg"
          centered
        >
          <ModalHeader className="p-2" toggle={() => this.toggle()}>
            {this.lang("QR Scanner")}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-12">
                <NewScanQR
                  legacyMode={legacyMode}
                  scanQrData={this.state.scanQrData}
                  handleScanWebCam={this.handleScanWebCam}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            {" "}
            <Button
              className="btn-danger"
              onClick={() => this.toggle("cancel")}
            >
              {this.lang("Cancel")}
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

//export default Colors;
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(NewCreateQr);
